import React, { useCallback, useEffect } from "react";
import { Modal } from "semantic-ui-react";
import { useSelector, useDispatch } from "react-redux";
import {
  authenticateUser,
  checkUserLoggedIn
} from "../../../redux/geofence/actions";
import { GoogleLogin } from "@react-oauth/google";

function LoginModal() {
  const userAuthenticated = useSelector(
    ({ geofence }) => geofence.userAuthenticated
  );
  const dispatch = useDispatch();
  useEffect(() => {
    if (userAuthenticated === undefined) {
      dispatch(checkUserLoggedIn());
    }
  }, [userAuthenticated, dispatch]);
  const loginHandler = useCallback(
    googleUser => {
      const id_token = googleUser.credential;
      dispatch(authenticateUser(id_token));
      /*
      if (window.gapi.auth2.getAuthInstance()) {
        window.gapi.auth2
          .getAuthInstance()
          .isSignedIn.listen(state => dispatch(setUserAuthenticated(state)));
      }*/
    },
    [dispatch]
  );

  return (
    <div>
      <Modal open={!userAuthenticated} size="tiny">
        <Modal.Content className="center-text">
          <GoogleLogin onSuccess={loginHandler} onError={console.error} />; ,
        </Modal.Content>
      </Modal>
    </div>
  );
}

LoginModal.defaultProps = {};

LoginModal.propTypes = {};

export default LoginModal;
